import './ProgressBar.css';

interface ProgressBarProps {
  progress: number; // 0-100
  label?: string;
  showPercentage?: boolean;
  variant?: 'primary' | 'success' | 'warning' | 'error';
  size?: 'small' | 'medium' | 'large';
  animated?: boolean;
  className?: string;
}

export default function ProgressBar({
  progress,
  label,
  showPercentage = true,
  variant = 'primary',
  size = 'medium',
  animated = true,
  className = '',
}: ProgressBarProps) {
  const clampedProgress = Math.min(100, Math.max(0, progress));
  
  return (
    <div className={`progress-bar-container ${className}`}>
      {label && (
        <div className="progress-bar-label">
          <span>{label}</span>
          {showPercentage && (
            <span className="progress-bar-percentage">{Math.round(clampedProgress)}%</span>
          )}
        </div>
      )}
      <div className={`progress-bar progress-bar-${size} progress-bar-${variant}`}>
        <div
          className={`progress-bar-fill ${animated ? 'progress-bar-animated' : ''}`}
          style={{ width: `${clampedProgress}%` }}
        />
      </div>
      {!label && showPercentage && (
        <div className="progress-bar-percentage-standalone">
          {Math.round(clampedProgress)}%
        </div>
      )}
    </div>
  );
}

interface IndeterminateProgressBarProps {
  label?: string;
  variant?: 'primary' | 'success' | 'warning' | 'error';
  size?: 'small' | 'medium' | 'large';
  className?: string;
}

export function IndeterminateProgressBar({
  label,
  variant = 'primary',
  size = 'medium',
  className = '',
}: IndeterminateProgressBarProps) {
  return (
    <div className={`progress-bar-container ${className}`}>
      {label && <div className="progress-bar-label">{label}</div>}
      <div className={`progress-bar progress-bar-${size} progress-bar-${variant} progress-bar-indeterminate`}>
        <div className="progress-bar-fill-indeterminate" />
      </div>
    </div>
  );
}

